import React from 'react';
import classname from '@search/classname/src';
import { Modal, Link } from '@vtblife/uikit';
import './styles.css';
import { useLkLinks } from '../../useLkLinks';

type Props = {
    onClose: () => void;
}

const cn = classname.bind(null, 'SavedSearchLimitModal');

export const SavedSearchLimitModal = (props: Props) => {
    const { savedSearchUrl } = useLkLinks();

    return (
        <Modal size='s' opened onClose={props.onClose}>
            <Modal.Title>Упс</Modal.Title>
            <p>
                У вас слишком много сохранённых поисков. Удалите лишние, чтобы сохранить этот.
            </p>
            <Modal.Actions>
                <span className={cn('saved-search-link')}>
                    <Link
                        href={savedSearchUrl}
                        target='blank'
                        variant='primary-minor'
                    >
                        Перейти в подписки
                    </Link>
                </span>
            </Modal.Actions>
        </Modal>
    );
};
